import React from 'react';
import { IconName, Illustration } from '@klp/design/Illustrations';
import type { Theme } from '@material-ui/core';
import { IconButton, ListItem, ListItemIcon } from '@material-ui/core';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import classNames from 'classnames';

type ByggSelectorToggleProps = {
    open: boolean;
    toggleOpen: () => void;
};

const styles = (theme: Theme) => ({
    icon: {
        transition: theme.byggSelector.transition,
    },
    iconRotated: {
        transform: 'rotate(180deg)',
    },
});

export const ByggSelectorToggle: React.FC<ByggSelectorToggleProps> = ({
    open,
    toggleOpen,
}) => {
    const classes = useKlpStyles({}, styles);
    return (
        <ListItem disableGutters={true} className="ByggSelector__ListItem">
            <ListItemIcon>
                <IconButton onClick={toggleOpen}>
                    <Illustration
                        className={classNames(classes.icon, {
                            [classes.iconRotated]: open,
                        })}
                        icon={IconName.RIGHT}
                        size="small"
                        klpPalette="secondary"
                        klpColor="main"
                    />
                </IconButton>
            </ListItemIcon>
        </ListItem>
    );
};
